import { ExportColumn } from '../../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'otherConsideration',
    header: 'Item',
    type: 'text',
    width: 40,
  },
  {
    key: 'description',
    header: 'Description',
    type: 'text',
    placeholder: 'Not Provided',
    width: 80,
  },
  {
    key: 'impactOnMitigation',
    header: 'Impact on Mitigation Timeline (months)',
    type: 'number',
    width: 40,
  },
  {
    key: 'firstName',
    header: 'First Name',
    type: 'text',
    placeholder: 'Not Provided',
    width: 30,
  },
  {
    key: 'lastName',
    header: 'Last Name',
    type: 'text',
    placeholder: 'Not Provided',
    width: 30,
  },
  {
    key: 'email',
    header: 'Email',
    type: 'email',
    placeholder: 'Not Provided',
    width: 30,
  },
];
